<div class="alv-card">
  @if (valittuKuukausiObservable | async; as valittuKuukausi) {
    <div class="light-blue-text" style="text-align: right; float: right">{{ valittuKuukausi.month }} / {{ valittuKuukausi.year }}</div>
  }
  @if (draftObservable | async; as draft) {
    @if (!(draftLoadingSubject | async)) {
      <h2 class="light-blue-text alv-otsikko">Yhteisömyynnit</h2>
      <div style="padding: 0 1em">
        @for (rivi of computeTotalsForAlvRivi(draft.rivit); track rivi) {
          <div>
            <p style="margin-bottom: 0">{{ rivi.alvTunnus }}</p>
            <table class="alv-table" style="padding: 1em">
              <tbody>
                <tr>
                  <td>Tavaramyynnit</td>
                  <td>{{ rivi.tavaramyynnit | lmoney: 'EUR' | async }}</td>
                </tr>
                <tr>
                  <td>Palvelumyynnit</td>
                  <td>{{ rivi.palvelumyynnit | lmoney: 'EUR' | async }}</td>
                </tr>
                <tr>
                  <td>Kolmikantamyynnit</td>
                  <td>{{ rivi.kolmikantamyynnit | lmoney: 'EUR' | async }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        }
      </div>
    }
    @if (draftLoadingSubject | async) {
      <div style="padding: 2em; text-align: center">
        <p>Ladataan...</p>
      </div>
    }
  }
  @if (!(draftObservable | async) && !(draftLoadingSubject | async)) {
    <div style="padding: 2em; text-align: center; color: #666">
      <p>Luonnos yhteisömyynti-ilmoitusta ei löytynyt tälle kuukaudelle.</p>
    </div>
  }

  @if (errorMessageObservable | async; as virhe) {
    <div class="lemon-error" style="margin: 20px; font-weight: bold; text-align: center">
      {{ virhe }}
    </div>
  }

  <div style="display: flex; justify-content: center; margin-top: 1.5em">
    <!-- <app-primary-button [disabled]="!(voidaanLahettaaObservable | async)" (click)="laheta()" actionId="Lähetä yhteisömyynti-ilmoitus" styles="line-height: 35px;">
    Lähetä
  </app-primary-button>
  <app-primary-button *ngIf="voidaanLahettaaVaikkaTiedotEivatMuuttuneetObservable | async" (click)="laheta(true)" actionId="Avasi dialogin: Lähetä yhteisömyynti-ilmoitus uudelleen (vain superit)" styles="line-height: 35px; margin-left: 15px;">
    Lähetä uudelleen, vaikka tiedot eivät muuttuneet (VAIN SUPERIT)
  </app-primary-button> -->
  </div>

  <div style="position: relative; height: 20px">
    <div style="text-align: right; position: absolute; right: 15px; bottom: -5px; color: darkgray; font-size: 80%; width: 600px">
      @if (tallentamattomiaMuutoksiaObservable | async; as onMuutoksia) {
        <span style="font-size: 16px; position: absolute; top: -17px; right: -14px">
          @if (kuukausiNumberObservable | async; as kuukausiNumber) {
            Ilmoittamattomia yhteisömyyntejä kaudelta {{ formatNumberMonthForDisplay(kuukausiNumber) }}
            <i class="fa fa-exclamation-triangle yellow-text" style="font-size: 20px; padding-left: 3px"></i>
          }
        </span>
      }
    </div>
  </div>
</div>

<div>
  <h3 class="light-blue-text alv-otsikko" style="margin: 1em 0">Lähetetyt yhteisömyynti-ilmoitukset</h3>

  @if (historyLoadingSubject | async) {
    <div style="display: flex; height: 200px; justify-content: center; align-items: center">
      <mat-spinner mode="indeterminate"></mat-spinner>
    </div>
  }

  <div [style.display]="(historyLoadingSubject | async) ? 'none' : 'block'">
    @for (ilmoitus of aikaisemmatIlmoituksetObservable | async; track ilmoitus) {
      <div class="alv-card dark-gray-text">
        <div class="light-blue-text" style="text-align: right; float: right">
          {{ formatNumberMonthForDisplay(ilmoitus.jakso) }}
        </div>
        @if (ilmoitus.url) {
          <div style="clear: both">
            Data: <a [href]="ilmoitus.url" target="_BLANK">{{ ilmoitus.uri }}</a>
          </div>
        }
        <h2 class="alv-otsikko" style="padding: 1em 0 0 0; margin: 0; clear: both">Yhteisömyynnit</h2>
        <div style="padding: 0 1em">
          @for (rivi of computeTotalsForAlvRivi(ilmoitus.rivit); track rivi) {
            <div>
              <p style="font-weight: bold; margin-bottom: 0">{{ rivi.alvTunnus }}</p>
              <table class="alv-table" style="padding: 1em">
                <tbody>
                  <tr>
                    <td>Tavaramyynnit</td>
                    <td>{{ rivi.tavaramyynnit | lmoney: 'EUR' | async }}</td>
                  </tr>
                  <tr>
                    <td>Palvelumyynnit</td>
                    <td>{{ rivi.palvelumyynnit | lmoney: 'EUR' | async }}</td>
                  </tr>
                  <tr>
                    <td>Kolmikantamyynnit</td>
                    <td>{{ rivi.kolmikantamyynnit | lmoney: 'EUR' | async }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          }
        </div>
        <div style="margin-top: 5px; height: 20px; color: darkgray; font-size: 80%; display: flex; justify-content: flex-end">
          <div style="text-align: right">
            {{ ilmoitus.tallennustiedot }}
          </div>
        </div>
      </div>
    }

    @if ((aikaisemmatIlmoituksetObservable | async)?.length === 0) {
      <div style="padding: 2em; text-align: center; color: #666">
        <p>Ei aikaisempia yhteisömyynti-ilmoituksia tälle kuukaudelle.</p>
      </div>
    }
  </div>
</div>
